const paidByKeys = [
  'agency',
  'agent',
  'marketing',
  'vendor',
] as const

export type PaidByKey = typeof paidByKeys[number]

type PaidByOption = {
  key: PaidByKey,
  text: string,
}

export const paidByOptions: PaidByOption[] = [
  { key: 'agency', text: 'Agency' },
  { key: 'agent', text: 'Agent' },
  { key: 'marketing', text: 'Marketing' },
  { key: 'vendor', text: 'Vendor' },
]

export const getPaidByTitleByKey = (key: PaidByKey) => {
  const selectedPayee = paidByOptions.find(payee => payee.key === key)
  return selectedPayee?.text || ''
}

const paymentMethodKeys = [
  'CAMPAIGN_AGENT',
  'CASH',
  'CHEQUE',
  'CREDIT_CARD',
  'EFT',
  'FINANCE_APPLICATION',
  'SALE_COMMISSION',
] as const

export type PaymentMethodKey = typeof paymentMethodKeys[number]

type PaymentMethod = {
  key: PaymentMethodKey,
  text: string,
}

export const paymentMethods: PaymentMethod[] = [
  { key: 'CAMPAIGN_AGENT', text: 'Campaign Agent' },
  { key: 'CASH', text: 'Cash' },
  { key: 'CHEQUE', text: 'Cheque' },
  { key: 'CREDIT_CARD', text: 'Credit Card' },
  { key: 'EFT', text: 'EFT' },
  { key: 'FINANCE_APPLICATION', text: 'Finance Application' },
  { key: 'SALE_COMMISSION', text: 'Sale Commission' },
]

export const getPaymentMethodByKey = (key: PaymentMethodKey) => {
  const paymentMethod = paymentMethods.find(method => method.key === key)
  return paymentMethod?.text || ''
}
